import React from "react";
import { ToggleButton, ToggleButtonProps } from "@/components/ToggleButton";
import { scentMapping } from "@/helpers/scentMapping";
import { cn } from "@/helpers/utils";
import { SvgSrcIcon } from "@/components/SvgSrcIcon";

interface ScentButtonProps extends Omit<ToggleButtonProps, "label" | "name"> {
  scent: string;
}

const ScentButton = ({
  scent,
  onClick,
  onBlur,
  onFocus,
  onMouseEnter,
  onMouseLeave,
  selected,
  ...rest
}: ScentButtonProps) => (
  <ToggleButton
    {...rest}
    className="group h-auto overflow-hidden rounded-full !p-0 md:h-auto"
    label={
      <div
        className={cn(
          scentMapping[scent]?.bgColor,
          "flex items-center group-hover:bg-primary"
        )}
      >
        <SvgSrcIcon
          className="group-hover:brightness-0 group-hover:invert"
          src={scentMapping[scent]?.src}
          height={40}
          width={40}
          title={scent}
        />
      </div>
    }
    selected={selected}
    onClick={onClick}
    onBlur={onBlur}
    onFocus={onFocus}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    data-id="scents-button"
    name="scent-selector-buttons"
  />
);

interface ScentSelectorProps {
  scents: string[];
  onScentSelect: (value: string) => void;
  onScentFocus?: (value: string) => void;
  onScentUnfocus?: () => void;
  onBlur?: () => void;
  value: string;
}

export const ScentSelector = ({
  scents,
  onScentSelect,
  onScentFocus,
  onScentUnfocus,
  onBlur,
  value,
}: ScentSelectorProps) => (
  <div className="space-x-2" role="radiogroup">
    {scents.map((x) => {
      return (
        <ScentButton
          key={x}
          scent={x}
          onClick={() => {
            onScentSelect(x);
          }}
          onFocus={() => {
            onScentFocus?.(x);
          }}
          onMouseEnter={() => {
            onScentFocus?.(x);
          }}
          onMouseLeave={() => {
            onScentUnfocus?.();
          }}
          onBlur={() => {
            onBlur?.();
          }}
          selected={value === x}
        />
      );
    })}
  </div>
);
